module.exports = __webpack_public_path__ + "img/658c092.png";